import { gql } from "@apollo/client";

export const WALLET_OFFER_CREATE_MUTATION = gql`
  mutation WalletOfferCreate($input: WalletOfferCreateInput!) {
    walletOfferCreate(input: $input) {
      offer {
        id
        title
        description
        code
        offerType
        minTopupAmount
        bonusAmount
        cashbackPercent
        maxBonusCap
        validFrom
        validTo
        promoValidityDays
        isTargeted
        targetType
        allowedUsersCount
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WALLET_OFFER_UPDATE_MUTATION = gql`
  mutation WalletOfferUpdate($id: ID!, $input: WalletOfferUpdateInput!) {
    walletOfferUpdate(id: $id, input: $input) {
      offer {
        id
        title
        description
        code
        offerType
        minTopupAmount
        bonusAmount
        cashbackPercent
        maxBonusCap
        validFrom
        validTo
        promoValidityDays
        isTargeted
        targetType
        allowedUsersCount
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WALLET_OFFER_DELETE_MUTATION = gql`
  mutation WalletOfferDelete($id: ID!) {
    walletOfferDelete(id: $id) {
      offer {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WALLET_STAFF_ADJUSTMENT_MUTATION = gql`
  mutation WalletStaffAdjustment(
    $userId: ID!
    $amount: Float!
    $balanceSource: String!
    $entryType: String!
    $reason: String!
  ) {
    walletStaffAdjustment(
      userId: $userId
      amount: $amount
      balanceSource: $balanceSource
      entryType: $entryType
      reason: $reason
    ) {
      wallet {
        id
        currentRealBalance
        currentPromoBalance
        reservedRealBalance
        reservedPromoBalance
        availableBalance
        totalBalance
      }
      ledgerEntry {
        id
        entryType
        balanceSource
        amount
        description
        createdAt
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
